import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import Spinner from '@components/spinner'

class QuickLogin extends Component {
  static propTypes = {
    userStore: PropTypes.object,
    growlStore: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      loading: false
    })

    const { token, hash, location } = queryString.parse(
      this.props.location.search
    )

    if (token) {
      props.userStore
        .quickLogin(token)
        .then(() => props.history.push(location))
        .catch(error => {
          props.history.push('/auth/login')
          if (
            error.statusCode === 401 &&
            error.message === 'Invalid token format'
          ) {
            props.growlStore.showError(
              'Could not log you in via quick login link. Please log in using your credentials.'
            )
          } else {
            props.growlStore.showError(error)
          }
        })
    }

    if (hash) {
      props.userStore
        .quickLoginHash(hash)
        .then(() => props.history.push(location))
        .catch(error => {
          props.history.push('/auth/login')
          if (
            error.statusCode === 401 &&
            error.message === 'Invalid token hash'
          ) {
            props.growlStore.showError(
              'Could not log you in via quick login link. Please log in using your credentials.'
            )
          } else {
            props.growlStore.showError(error)
          }
        })
    }
  }

  render () {
    return (
      <div>
        <h1 className='text-center'>Signing you into the application</h1>
        <Spinner />
      </div>
    )
  }
}

export default withRouter(
  inject('userStore', 'growlStore')(observer(QuickLogin))
)
